import { render, staticRenderFns } from "./UserRule.vue?vue&type=template&id=20e00b0d&scoped=true"
import script from "./UserRule.vue?vue&type=script&lang=js"
export * from "./UserRule.vue?vue&type=script&lang=js"
import style0 from "./UserRule.vue?vue&type=style&index=0&id=20e00b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e00b0d",
  null
  
)

export default component.exports